import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = 'https://api.civilcadpro.in/api';

function GeoAnalytics() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGeoData();
  }, []);

  const fetchGeoData = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/analytics/usage/geo`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setData(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="card">Loading...</div>;
  if (!data) return <div className="card">No data</div>;

  const maxCount = data.byCountry[0]?.count || 1;
  const totalUsers = data.byCountry.reduce((sum, c) => sum + c.count, 0);

  return (
    <div>
      <h2 style={{ marginBottom: 25, color: '#1a1a2e' }}>Geographic Analytics</h2>

      {/* Stats Cards */}
      <div className="stats-grid">
        <div className="stat-card orange">
          <h3>{data.byCountry.length}</h3>
          <p>Countries</p>
        </div>
        <div className="stat-card green">
          <h3>{data.geoStats.length}</h3>
          <p>Cities</p>
        </div>
        <div className="stat-card blue">
          <h3>{totalUsers.toLocaleString()}</h3>
          <p>Total Commands</p>
        </div>
      </div>

      {/* Country Bar Chart */}
      <div className="card">
        <h2>Commands by Country (Last 30 Days)</h2>
        {data.byCountry.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#888', padding: 30 }}>No data</p>
        ) : (
          <div style={{ marginTop: 20 }}>
            {data.byCountry.map((country, idx) => (
              <div key={idx} style={{ marginBottom: 18 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}>
                  <span style={{ fontWeight: 600, fontSize: 14 }}>
                    {country._id || 'Unknown'} 
                    <span style={{ color: '#888', fontWeight: 400, fontSize: 12, marginLeft: 8 }}>
                      ({country.cities?.length || 0} cities)
                    </span>
                  </span>
                  <span style={{ fontWeight: 600, fontSize: 14, color: '#ec700b' }}>
                    {country.count.toLocaleString()}
                  </span>
                </div>
                <div style={{
                  width: '100%', height: 24, background: '#f0f0f0', borderRadius: 12, overflow: 'hidden'
                }}>
                  <div style={{
                    width: `${(country.count / maxCount) * 100}%`,
                    height: '100%',
                    background: `linear-gradient(90deg, #ec700b, #ff9f43)`,
                    borderRadius: 12,
                    transition: 'width 0.5s',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: 10,
                    minWidth: country.count > 0 ? 40 : 0
                  }}>
                    {country.count > 0 && (
                      <span style={{ color: 'white', fontSize: 11, fontWeight: 600 }}>
                        {((country.count / totalUsers) * 100).toFixed(1)}%
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* City Details Table */}
      <div className="card">
        <h2>Top Cities</h2>
        {data.geoStats.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#888', padding: 30 }}>No data</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>City</th>
                <th>State</th>
                <th>Country</th>
                <th>Commands</th>
                <th>Last Active</th>
              </tr>
            </thead>
            <tbody>
              {data.geoStats.map((geo, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td><strong>{geo._id.city || 'Unknown'}</strong></td>
                  <td>{geo._id.state || '-'}</td>
                  <td>{geo._id.country || '-'}</td>
                  <td>
                    <span style={{ 
                      background: '#ec700b', color: 'white', padding: '4px 10px', 
                      borderRadius: 12, fontSize: 12, fontWeight: 600 
                    }}>
                      {geo.count}
                    </span>
                  </td>
                  <td>{new Date(geo.lastUsed).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default GeoAnalytics;